import Swiper from 'swiper';
import { Autoplay, Grid, Navigation } from 'swiper/modules';
import Alpine from 'alpinejs';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initSubProgramsCards() {
  Alpine.data(
    'subProgramsCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.swiper-sub-programs');
        if (swiperEl) {
          this.initSwiper(swiperEl as HTMLElement);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation, Grid],
          spaceBetween: 20,
          autoHeight: true,
          slidesPerView: 1,
          navigation: {
            nextEl: '.swiper-subprograms__buttons .swiper-button-next',
            prevEl: '.swiper-subprograms__buttons .swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 2,
              grid: {
                fill: 'row',
                rows: 2,
              },
            },
          },
        });
      },
    }),
  );
}
